import { v4 as uuidv4 } from 'uuid';

// dont use this fucntion to clone , object having functions, undefined, Date and class...
export const deepCopy = (obj) => {
    return JSON.parse(JSON.stringify(obj));
};


export function isValidJson(jsonString) {
    try {
        JSON.parse(jsonString);
        return true;
    } catch (error) {
        return false;
    }
}


export const convertArrayToJson = (list) => {
    let json = {};
    list.map(item => {
        json[item.key] = item.value;
    })
    return JSON.stringify(json);
}


export const convertJsonToList = (json) => {
    let list = [];

    if (typeof json === "string") {
        json = JSON.parse(json)
    }

    Object.entries(json).map(item => {
        list.push({ id: uuidv4(), key: item[0], value: item[1] })
    });

    return list
}
